// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsCollectionsEditTemplate_heading__RTm-T","buttonLink":"ReportingDetailsCollectionsEditTemplate_buttonLink__aE1hw"};